module.exports = __webpack_public_path__ + "img/14.03c982b3.jpg";